module.exports = __webpack_public_path__ + "img/pageform.a5c5f721.svg";